<template>
    <div>
        <Toolbar>
            <BackButton to="store groups" :href="$route('stores.groups')"/>
        </Toolbar>

        <Card>
            <template v-slot:title>{{ group.name }}</template>
            <template v-slot:description>Manage store group</template>

            <div v-if="stores.length > 0" class="table-responsive">
                <table class="table table-hover table-vertical-center">
                    <thead>
                    <tr>
                        <th>{{ __('general.store') }}</th>
                        <th>{{ __('general.address.address') }}</th>
                        <th class="text-right">{{ __('general.actions') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="store in stores">
                        <td>
                            {{ store.attributes.name }}
                        </td>
                        <td>
                            <div class="d-flex flex-row gap-2">
                                <Badge class="text-uppercase">{{ store.attributes.address.country }}</Badge>
                                <StoreAddress :store="store"/>
                            </div>
                        </td>
                        <td class="text-right">
                            <button class="btn btn-xs btn-light-danger" @click="removeStoreFromGroup(store)">
                                <i class="fas fa-trash"/>
                                {{ __('actions.remove_thing', {thing: __('general.store')}) }}
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-else class="text-muted">
                There are no stores in this group yet.
            </div>
        </Card>

        <Card class="mt-3">
            <template v-slot:title>Add store</template>
            <template v-slot:description>Search a store to add to the group</template>

            <SearchStore v-model="selectedStoreToAdd"/>

            <template v-slot:footer>
                <button class="btn btn-primary" :disabled="selectedStoreToAdd === null" @click="addSelectedStore">
                    <i class="fas fa-plus-square"/>
                    {{ __('actions.add_thing', {thing: __('general.store')}) }}
                </button>
            </template>
        </Card>
    </div>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import StoreAddress from "@components/Store/StoreAddress.vue";
import Badge from "@components/Badge.vue";
import Toolbar from "@components/Toolbar.vue";
import BackButton from "@components/BackButton.vue";
import SearchStore from "@components/Store/SearchStore.vue";

export default {
    components: {SearchStore, BackButton, Toolbar, Badge, StoreAddress, Card},

    props: {
        group: Object,
        stores: Array
    },

    data() {
        return {
            selectedStoreToAdd: null
        }
    },

    methods: {
        addSelectedStore() {
            if (this.selectedStoreToAdd === null) {
                return;
            }

            this.$inertia.put(this.$route('stores.groups.stores.detach', [this.group.id, this.selectedStoreToAdd.id]))
            this.selectedStoreToAdd = null;
        },

        removeStoreFromGroup(store) {
            Swal.fire({
                title: `Do you want to remove "${store.attributes.name}"?`,
                text: "The store won't be part of the group anymore.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
            }).then(async (result) => {
                if (result.value) {
                    this.$inertia.delete(this.$route('stores.groups.stores.detach', [this.group.id, store.id]))
                }
            });
        }
    }
}
</script>
